var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMasordenGrisSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.84 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#606060;}.cls-2{fill:#53e4b1;}.cls-3{fill:#0dda9a;}.cls-4{fill:#05cbdb;}.cls-5{fill:#0da9c6;}.cls-6{fill:#0386c8;}.cls-7{fill:#0699e6;}.cls-8{fill:#0db2fd;}.cls-9{fill:#0ac5f4;}.cls-10{fill:#0ddada;}.cls-11{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotipo_sobre_Oscuro",
    "data-name": "Logotipo sobre Oscuro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.21,15.38a9.9,9.9,0,0,1-.5,3.2,7.16,7.16,0,0,1-1.45,2.51,6.57,6.57,0,0,1-2.35,1.63,8.81,8.81,0,0,1-6.34,0,6.45,6.45,0,0,1-2.35-1.63,7.18,7.18,0,0,1-1.46-2.51,9.9,9.9,0,0,1-.49-3.2,9.65,9.65,0,0,1,.49-3.21,7.14,7.14,0,0,1,1.46-2.5A6.59,6.59,0,0,1,43.57,8a9,9,0,0,1,6.34,0,6.66,6.66,0,0,1,2.35,1.63,7.26,7.26,0,0,1,1.45,2.51A9.91,9.91,0,0,1,54.21,15.38Zm-2.9,0A7.77,7.77,0,0,0,51,12.94a4.85,4.85,0,0,0-1-1.74,3.6,3.6,0,0,0-1.44-1,5,5,0,0,0-3.67,0,3.67,3.67,0,0,0-1.44,1,4.84,4.84,0,0,0-1,1.74,7.8,7.8,0,0,0-.35,2.44,7.8,7.8,0,0,0,.35,2.44,5,5,0,0,0,1,1.73,4,4,0,0,0,1.44,1,4.61,4.61,0,0,0,1.84.35,4.77,4.77,0,0,0,1.83-.35,3.92,3.92,0,0,0,1.45-1A5,5,0,0,0,51,17.82,7.82,7.82,0,0,0,51.31,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.54,12.32A4.24,4.24,0,0,1,67.65,15a5.28,5.28,0,0,1-2.75,1.65v0L69.46,23H66.1L61.92,17.1H60V23H57.19V7.73h4.66A18.17,18.17,0,0,1,64,7.86a8,8,0,0,1,1.71.4A4.44,4.44,0,0,1,67.8,9.78,4.22,4.22,0,0,1,68.54,12.32Zm-7.16,2.44A12.6,12.6,0,0,0,63,14.67a5.14,5.14,0,0,0,1.13-.25,2.25,2.25,0,0,0,1.17-.88,2.43,2.43,0,0,0,.33-1.27,2.25,2.25,0,0,0-.26-1.09,1.7,1.7,0,0,0-.88-.75,3.86,3.86,0,0,0-1-.27,10.39,10.39,0,0,0-1.5-.09H60v4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.93,23V7.73h4l1.1,0c.37,0,.73.06,1.08.11s.69.1,1,.16a9.2,9.2,0,0,1,.91.24,7.89,7.89,0,0,1,2.16,1.05,6.33,6.33,0,0,1,1.58,1.56,7,7,0,0,1,1,2,8.48,8.48,0,0,1,.33,2.42,9,9,0,0,1-.28,2.31,6.79,6.79,0,0,1-.83,2,6.4,6.4,0,0,1-1.42,1.57,7.12,7.12,0,0,1-2,1.11,10.35,10.35,0,0,1-2.21.55,18.08,18.08,0,0,1-2.79.19Zm4-2.35A8.93,8.93,0,0,0,79.74,20a4.12,4.12,0,0,0,1.86-1.76,6.11,6.11,0,0,0,.63-2.95A6.3,6.3,0,0,0,82,13.6a4.4,4.4,0,0,0-.59-1.34,4.15,4.15,0,0,0-1-1,5.61,5.61,0,0,0-1.25-.7,6.24,6.24,0,0,0-1.46-.36,12.15,12.15,0,0,0-1.8-.12H74.73v10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.91,20.67h7.54V23H88.1V7.73H98v2.34H90.91V14H97v2.34H90.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.42,14.83q1.65,2.34,2.68,4.16h.07c-.1-2-.14-3.43-.14-4.34V7.73h2.81V23h-3l-5-7c-.87-1.22-1.78-2.64-2.72-4.24h-.07c.09,1.87.14,3.32.14,4.35V23h-2.81V7.73h2.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.86 30 36.07 30 36.07 8.79 32.55 8.79 35.73 26.19 14.86 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.86 30 35.73 26.19 32.55 8.79 30.62 8.79 35.17 23.88 14.86 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "30.62 8.79 27.17 8.79 33.28 19.48 14.86 30 35.17 23.88 30.62 8.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "27.17 8.79 23.8 8.79 30.04 15.19 14.86 30 33.28 19.48 27.17 8.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "14.86 30 30.04 15.19 23.8 8.79 14.86 8.79 14.86 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "22.16 7.1 21.06 5.98 8.64 9.72 14.86 30 14.86 8.79 23.8 8.79 22.16 7.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "21.06 5.98 18.58 3.44 4.29 11.58 14.86 30 8.64 9.72 21.06 5.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "18.58 3.44 15.23 0 0 14.8 14.86 30 4.29 11.58 18.58 3.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "21.06 5.98 24.9 4.82 27.17 8.79 23.8 8.79 21.06 5.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "24.9 4.82 22.75 1.05 18.58 3.44 21.06 5.98 24.9 4.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.9 4.82 29.05 3.57 29.7 5.73 25.82 6.43 24.9 4.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.17 8.79 30.62 8.79 29.7 5.73 25.82 6.43 27.17 8.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.7 5.73 31.92 5.32 32.55 8.79 30.62 8.79 29.7 5.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.61,15.68h-7v6.87H17.26V15.68h-7V13.2h6.86V6.33h2.48V13.2h7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMasordenGrisSmall);
export default __webpack_public_path__ + "static/media/logo-masorden-gris-small.4b1e1613f3d7b9d149fe9b97b6558613.svg";
export { ForwardRef as ReactComponent };